import moduleLoader from "flow/wrappers/moduleLoader";
import { ScriptPathConfig } from "flow/entities/ScriptPathConfig";
import { Dictionary } from "flow/api/types";

function registerPaths(baseUrl: string, scriptPathConfigs: ScriptPathConfig[], cacheBuster: string) {
    const paths: Dictionary = {};
    scriptPathConfigs.forEach(pathConfig => {
        if (pathConfig.key) {
            paths[pathConfig.key] = baseUrl + pathConfig.path;
            window.cacheBusters[pathConfig.key] = cacheBuster;
        }
    });

    moduleLoader.addPaths(paths);
}

export default {
    registerPaths: registerPaths
};
